import * as React from 'react';
import styled from 'styled-components';
import PricingItem from './PricingItem';

const TotalPricingComponentContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export interface Item {
  title: string;
  price: string;
  dollarValue: number;
}

interface props {
  items: Item[];
}

const TotalPricingComponent = (props: props) => {
  return (
    <TotalPricingComponentContainer>
      {props.items.map(item => (
        <PricingItem
          key={item.title}
          style={{ marginBottom: 8 }}
          title={item.title}
          price={item.price}
        />
      ))}
      <hr style={{ width: '100%' }} />
      <PricingItem
        title="Total"
        price={`\$${props.items.reduce((a, b) => a + b.dollarValue, 0)}`}
      />
    </TotalPricingComponentContainer>
  );
};

export default TotalPricingComponent;



// WEBPACK FOOTER //
// ./src/components/TotalPricingComponent.tsx